// extracted by mini-css-extract-plugin
module.exports = {"newsHeader":"xA1ceAyC"};